import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { FeatureFlagValue } from '@app/feature-toggle-list';
import { FeatureToggleService } from '@app/shared/services/feature-toggle.service';

@Directive({
  selector: '[ngFeatureFlag]',
})
export class FeatureFlagDirective {
  // NOTE: THIS IS DEPRECATED PLEASE USE FeatureFlagPipe

  private featureFlagEnabled :boolean = false;
  private isUndefined :boolean = false;

  constructor(
    private ft :FeatureToggleService,
    private templateRef :TemplateRef<any>,
    private viewContainer :ViewContainerRef,
  ) {}

  @Input()
  set ngFeatureFlag(featureFlag :FeatureFlagValue) {
    this.isUndefined = featureFlag === undefined || featureFlag === null;
    this.featureFlagEnabled = this.ft.featureEnabled(featureFlag);
  }

  @Input()
  set ngFeatureFlagIsDisabled(state :boolean) {
    this.featureFlagEnabled = this.isUndefined
      ? false
      : state
        ? !this.featureFlagEnabled
        : this.featureFlagEnabled;
    this.updateView();
  }

  private updateView() :void {
    if (this.featureFlagEnabled) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
